import TechnicalInformation from 'containers/Slices/TechnicalInformation';

export const seriesTechnicalTab = (
  block,
  type,
  index,
  primaryFontColor,
  secondaryFontColor,
) => {
  switch (type) {
    case 'information_tab':
      return (
        <TechnicalInformation
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    default:
      return '';
  }
};
